module.exports = __webpack_public_path__ + "img/Jaime Cirilo Santiago_Logística.d2edd6ce.png";